export enum Sentiment {
    Positive = 1,
    Neutral = 0,
    Negative = -1
}
